import axios from 'axios'

const payUrl = "/bxpt-cashier-desk/pay_new/doPay";
export function wxPay(data,callback) {
    let myData = data;
    axios.post(payUrl,myData).then((res) => {
        if (res.data.result == 1){
            let data = JSON.parse(res.data.data.reqUrl);
            wxPayReady(function () {
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', {
                        "appId":data.appId,     //公众号名称，由商户传入
                        "timeStamp":data.timeStamp,         //时间戳，自1970年以来的秒数
                        "nonceStr":data.nonceStr, //随机串
                        "package":data.package,
                        "signType":data.signType,         //微信签名方式：
                        "paySign":data.paySign //微信签名
                    },
                    function(res){
                        callback();
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                            //微信返回成功
                            if(myData.fcallbackUrl){
                                location.href = myData.fcallbackUrl;
                            }
                        }
                    });
            })
        }
    })
};

function wxPayReady(callback) {
    //WeixinJSBridge 为weixin的浏览器对象
    if (typeof WeixinJSBridge == "undefined"){
        if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', callback, false);
        }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', callback);
            document.attachEvent('onWeixinJSBridgeReady', callback);
        }
    }else{
        callback();
    }
}